import {useState} from 'react';
import {getShopDetails} from 'ultra/helpers/shop';

import {useNavigationStore} from '../../../../../../../../Stores/navigation';

import ShopProductsList from '../../../../../../Widgets/ShopProductsList'
import CKEditorContent from '../../../../../../Widgets/CKEditorContent'
import BreadcrumbsWidget from '../../../../../../Widgets/Breadcrumbs';
import TitleWidget from '../../../../../../Widgets/Title';
import TopPagePicture from '../../../../../../Widgets/TopPagePicture';

import './index.scss'

export default function Template(props) {
    const {content, config, children, permits, breadcrumbs} = props;
    const [shop] = useState(getShopDetails(content, breadcrumbs)?.shop);

    const {contentLoading} = useNavigationStore();
    
    return <div className="ShopSectionTemplate">
        {content.banner && (!content.showPagination || (content.showPagination && children?.pagination?.current === 1))
            && <TopPagePicture cutHeightForDesktop showSkeleton={contentLoading} image={content.banner} hidden={config?.templateOptions?.topPagePictureHidden}/>}

        <TitleWidget
            permits={permits} content={content} config={config}
            breadcrumbs={breadcrumbs}          
            hide={content.hideTitle}  
        />
        <BreadcrumbsWidget links={breadcrumbs} hide={content.hideBreadcrumbs}/>
        
        <div className="products">
            <ShopProductsList
                showSkeleton={contentLoading}
                items={children}
                showPagination={content.showPagination}
                
                currency={shop.partner_config.currency}
                breadcrumbs={breadcrumbs}
                content={content}
                config={config}
            />
        </div>

        <CKEditorContent content={content.description} />
    </div>
}
